// NOREWYN FIREBASE SYSTEM (V12.1 - CAMPUS)
import { initializeApp, getApps, getApp } from "firebase/app";
import { 
  getFirestore, 
  doc, 
  setDoc, 
  updateDoc, 
  deleteDoc, 
  onSnapshot, 
  collection, 
  query, 
  where, 
  addDoc, 
  orderBy, 
  limit, 
  getDoc, 
  getDocs, 
  serverTimestamp, 
  arrayUnion, 
  arrayRemove, 
  writeBatch,
  initializeFirestore 
} from "firebase/firestore";
import { getAuth, onAuthStateChanged, signInWithEmailAndPassword } from "firebase/auth";
import { getFunctions, httpsCallable } from "firebase/functions";
import { initializeAppCheck, ReCaptchaEnterpriseProvider } from "firebase/app-check";

const firebaseConfig = {
  apiKey: "AIzaSyCR_JnvfSDj55yu-9beopZZ2wsRhx6CkSg",
  authDomain: "penpalsdragons.firebaseapp.com",
  projectId: "penpalsdragons",
  storageBucket: "penpalsdragons.firebasestorage.app",
  messagingSenderId: "479794765294",
  appId: "1:479794765294:web:1c24d799af6f364819c2ff",
  measurementId: "G-7BNGKTEMNP"
};

// Initialize Firebase safely
const app = getApps().length === 0 ? initializeApp(firebaseConfig) : getApp();

// Initialize App Check (Kun i browser-miljø)
if (typeof window !== 'undefined') {
  if (window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1') {
    (window as any).FIREBASE_APPCHECK_DEBUG_TOKEN = true;
  }
  try {
    initializeAppCheck(app, {
      provider: new ReCaptchaEnterpriseProvider('6Lcw_6MqAAAAAHSG8m-7vXv2g_W-wXg7P5zX4Y2E'),
      isTokenAutoRefreshEnabled: true
    });
  } catch (err) {
    console.warn("App Check kunne ikke initialiseres.");
  }
}


const auth = getAuth(app);

// Firestore med Long Polling for stabilitet i IDX previews
const db = initializeFirestore(app, {
  experimentalForceLongPolling: true,
});

/** * FUNCTIONS REGION FIX (Inspireret af søstersiden)
 * Vi sætter regionen til europe-west3 for at matche jeres backend logik.
 */
const functions = getFunctions(app, "europe-west3");
const usFunctions = getFunctions(app, "us-central1"); // ← tilføj denne linje

// Hjælper til fejlsikret snapshot
export const safeOnSnapshot = (query: any, onNext: (snapshot: any) => void, onError?: (error: any) => void) => {
  return onSnapshot(query, onNext, (error) => {
    if (error.code === 'permission-denied') {
      console.warn("Magisk adgang nægtet.");
    } else {
      console.error("Firebase fejl:", error);
    }
  });
};

export { 
  db, 
  auth, 
  functions,
  usFunctions,
  httpsCallable,
  onAuthStateChanged, 
  signInWithEmailAndPassword, 
  doc, 
  setDoc, 
  updateDoc,
  deleteDoc,
  onSnapshot, 
  collection, 
  query, 
  where, 
  addDoc, 
  orderBy, 
  limit, 
  getDoc, 
  getDocs, 
  serverTimestamp, 
  arrayUnion, 
  arrayRemove, 
  writeBatch
};